import { nlpIntegration } from '@mi-front/api-clients';

/**
 * Returns the display key points for a topic: refined_key_points when present and non-empty, otherwise key_points.
 */
export function getTopicDisplayKeyPoints(topic: nlpIntegration.TopicOutDto): string[] {
  if (topic.refined_key_points?.length) {
    return topic.refined_key_points;
  }

  return topic.key_points ?? [];
}
